/** A refused write, in words for the tray (25B rule 9). */
import type { Failure } from "../offline/outbox";

/** The write, in words: its verb and what it was about. */
export function describe(failure: Failure): string {
  const { method, path, body } = failure.write;
  const verb = { POST: "Adding", PUT: "Saving", PATCH: "Changing", DELETE: "Deleting" }[method];
  const named =
    typeof body === "object" && body !== null
      ? ((body as Record<string, unknown>).title ?? (body as Record<string, unknown>).name)
      : undefined;
  const area = path.split("/")[2] ?? "it";
  return typeof named === "string" && named ? `${verb} “${named}” (${area})` : `${verb} in ${area}`;
}
